// import Homepage from './homepage'
import Loadable from 'react-loadable'

const Homepage = Loadable({
    loader: () => import(/* webpackChunkName: "homepageBeta" */ './homepage'),
    loading: () => null,
})

const HomepageRoute = () => <Homepage />

export default HomepageRoute
